// *****************
// Notificações Internas = p_notificacoesinternas.jsx
// autor: W de Paula / MVinfo
// data: 09/08/24 | 16:25h
// *****************




import React, { useState, useEffect } from 'react';
import apiaxios from "../../../../Services/apiaxios.js";
import { decrypt } from '../../../../Services/cryptoUtils.js';
import { p_getUserData } from "../../../../Services/p_userutils.js";
import Swal from 'sweetalert2';
import { AutoLogout } from '../../../../Services/autologout.js';

import Menu from '../../Components/Menu/p_menu.jsx';
import Footer from '../../../AgendexCliente/components/Footer/footer.jsx';
import './p_notificacoesinternas.css';

function NotificacoesInternas() {
    // const tokenASW = localStorage.getItem("tokenasw");
    const tokenASW = decrypt(localStorage.getItem('tokenasw'));
    useEffect(() => {
        const tokenlg = localStorage.getItem("tokenlg");
        
        if (!tokenASW || !tokenlg) {
            AutoLogout();
        }
    }, []);

    const initialUserData = p_getUserData();
    const [userId, setUserId] = useState(initialUserData.userId);
    // console.log('initialuserData', initialUserData, "userId após initiaUserData: ", userId);

    const [settings, setSettings] = useState({
        rect_email_agenda: 0,
        rect_email_cancela: 0,
        rect_email_24h: 0,
        rect_email_12h: 0,
        rect_email_6h: 0,
        rect_email_2h: 0,
        rect_email_1h: 0,
        som_notificacao: 0,
        vibrar_notificacao: 0,
    });

    const keyToLabelMap = {
        rect_email_agenda: 'Email de Agendamento',
        rect_email_cancela: 'Email de Cancelamento',
        rect_email_24h: 'Email 24hs antes do agendamento',
        rect_email_12h: 'Email 12hs antes do agendamento',
        rect_email_6h: 'Email 6hs antes do agendamento',
        rect_email_2h: 'Email 2hs antes do agendamento',
        rect_email_1h: 'Email 1h antes do agendamento',
        som_notificacao: 'Sons ao receber notificações',
        vibrar_notificacao: 'Vibrar ao receber notificações'
    };

    useEffect(() => {
        const fetchSettings = async () => {
            const keys = [
                'rect_email_agenda', 'rect_email_cancela', 'rect_email_24h',
                'rect_email_12h', 'rect_email_6h', 'rect_email_2h', 'rect_email_1h',
                'som_notificacao', 'vibrar_notificacao'
            ];

            const newSettings = { ...settings };

            for (const key of keys) {
                try {
                    const response = await apiaxios.get('/Usuario/ConfiguracoesWeb', {
                        params: { id_usuario: userId, chave: key, token: tokenASW }
                    });
                    if (response.data.retorno === 'OK') {
                        newSettings[key] = parseInt(response.data.valor, 10) || 0;
                    } else {
                        Swal.fire('Erro', `Falha ao carregar a configuração ${key}`, 'error');
                    }
                } catch (error) {
                    console.error(`Erro ao carregar a configuração ${key}:`, error);
                }
            }

            setSettings(newSettings);
        };

        fetchSettings();
    }, [userId]);

    const handleSwitchChange = async (key, value) => {
        try {
            const response = await apiaxios.put('/Usuario/ConfiguracoesWeb', {
                chave: key,
                valor: value,
                id_usuario: userId
            },
            {
                params: {
                    id_usuario: userId,
                    token: tokenASW
                }
            });

            if (response.data.retorno === 'OK') {
                setSettings(prevSettings => ({
                    ...prevSettings,
                    [key]: value
                }));
            } else {
                Swal.fire('Erro', `Falha ao atualizar a configuração ${key}`, 'error');
                // Reverter o estado do switch caso a atualização falhe
                setSettings(prevSettings => ({
                    ...prevSettings,
                    [key]: prevSettings[key] === 1 ? 0 : 1
                }));
            }
            } catch (error) {
                console.error(`Erro ao atualizar a configuração ${key}:`, error);
                Swal.fire('Erro', `Erro ao atualizar a configuração ${key}`, 'error');
                // Reverter o estado do switch caso a atualização falhe
                setSettings(prevSettings => ({
                    ...prevSettings,
                    [key]: prevSettings[key] === 1 ? 0 : 1
                }));
            }
    };

    return (
        <div className="container-fluid">
            <div className="row flex-nowrap">
                <div className="col-auto col-md-3 col-xl-2 px-sm-2 px-0">
                    <Menu page="notificacoesinternas" />
                </div>
                <div className="col py-3 me-3">
                    <h1>Notificações Internas</h1>
                    <hr />
                    {Object.keys(settings).map(key => (
                        <div className="form-check form-switch" key={key}>
                            <input
                                className="form-check-input"
                                type="checkbox"
                                role="switch"
                                id={key}
                                checked={settings[key] === 1}
                                onChange={(e) => handleSwitchChange(key, e.target.checked ? 1 : 0)}
                            />
                            <label className="form-check-label" htmlFor={key}>
                                {/* {key.replace(/_/g, ' ')} */}
                                {keyToLabelMap[key]}
                            </label>
                        </div>
                    ))}
                </div>
            </div>
            <Footer />
        </div>
    );
}

export default NotificacoesInternas;